import { FileCheck, Clock, CreditCard, Key } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function TrialProcessSection({ onOpenForm }) {
  const steps = [
    {
      number: "1",
      icon: FileCheck,
      title: "Cadastro simples",
      description: "Preencha seus dados básicos em menos de 2 minutos",
    },
    {
      number: "2",
      icon: FileCheck,
      title: "Acesso ao software",
      description: "Download disponibilizado após validação do cadastro",
    },
    {
      number: "3",
      icon: Clock,
      title: "Trial válido por 30 dias",
      description: "Acesso completo a todas as funcionalidades",
    },
    {
      number: "4",
      icon: Key,
      title: "Ativação definitiva",
      description: "Chave de ativação enviada por e-mail após confirmação do pagamento",
    },
  ];

  return (
    <section
      id="trial-process"
      className="relative py-16 md:py-32 bg-[#0F1115]"
      data-testid="trial-process-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Processo
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Como Funciona o <span className="text-[#F59E0B]">Teste Gratuito</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 hover:border-[#F59E0B]/50 transition-all"
              data-testid={`trial-step-${index}`}
            >
              {/* Step Number */}
              <div className="absolute -top-4 left-6 w-8 h-8 flex items-center justify-center bg-[#F59E0B] text-black font-bold text-sm rounded-sm">
                {step.number}
              </div>

              <div className="pt-4">
                <step.icon className="h-8 w-8 text-[#F59E0B] mb-4" />
                <h3 className="font-heading text-lg font-bold text-[#E5E7EB] mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-[#9CA3AF]">{step.description}</p>
              </div>

              {/* Connector Line (except last) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-0.5 bg-[#2A2F38]" />
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            onClick={onOpenForm}
            className="bg-[#10B981] text-white font-bold uppercase tracking-wide hover:bg-[#059669] transition-all rounded-sm px-10 py-6 text-base"
            data-testid="trial-process-cta"
          >
            Iniciar Teste Gratuito
          </Button>
          <p className="mt-4 text-sm text-[#6B7280]">
            Sem necessidade de cartão de crédito
          </p>
        </div>
      </div>
    </section>
  );
}
